export default __webpack_public_path__ + "static/media/icons-mobile.d3805079.svg";